<template>
  <div
    class="bg-white/80 backdrop-blur-xl rounded-2xl sm:rounded-3xl border p-4 sm:p-6 lg:p-8 border-gray-300"
  >
    <h3 class="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6">
      Quick Actions
    </h3>
    <div class="space-y-2 sm:space-y-3">
      <RouterLink
        to="/teacher"
        class="w-full bg-blue-50 hover:bg-blue-100 text-blue-700 font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-lg sm:rounded-xl transition-colors duration-200 flex items-center space-x-3 text-sm sm:text-base"
      >
        <Users class="w-4 h-4 sm:w-5 sm:h-5" />
        <span>View Teachers</span>
      </RouterLink>
      <RouterLink
        to="/students"
        class="w-full bg-green-50 hover:bg-green-100 text-green-700 font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-lg sm:rounded-xl transition-colors duration-200 flex items-center space-x-3 text-sm sm:text-base"
      >
        <UserCheck class="w-4 h-4 sm:w-5 sm:h-5" />
        <span>View Students</span>
      </RouterLink>
      <RouterLink
        to="/reports"
        class="w-full bg-purple-50 hover:bg-purple-100 text-purple-700 font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-lg sm:rounded-xl transition-colors duration-200 flex items-center space-x-3 text-sm sm:text-base"
      >
        <BarChart3 class="w-4 h-4 sm:w-5 sm:h-5" />
        <span>View Reports</span>
      </RouterLink>
      <RouterLink
        to="/setting"
        class="w-full bg-orange-50 hover:bg-orange-100 text-orange-700 font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-lg sm:rounded-xl transition-colors duration-200 flex items-center space-x-3 text-sm sm:text-base"
      >
        <Settings class="w-4 h-4 sm:w-5 sm:h-5" />
        <span>School Settings</span>
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
  import { Users, UserCheck, BarChart3, Settings } from "lucide-vue-next";
</script>
